export default __webpack_public_path__ + "static/media/Jonah-hill-silver.fc4fea6b.svg";